export const navigateWithParams = (
  navigate: (url: string) => void,
  route: "trending" | "stock",
  queryParams: Record<string, any> = {},
  symbol?: string
) => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;

    let normalizedKey = key;

    if (route === "stock") {
      // Time
      if (["time_range", "timeRange", "time"].includes(key)) normalizedKey = "timeRange";

      // Who
      if (["who", "whoValue", "user"].includes(key)) normalizedKey = "who";

      // OrderType
      if (["orderType", "order", "orderTypeValue"].includes(key)) normalizedKey = "orderType";

      // Subtype / Category
      if (["subtype", "category", "type"].includes(key)) normalizedKey = "subtype";

      // Sectors
      if (["sectors", "sector"].includes(key)) normalizedKey = "sectors";

      // Industries
      if (["industries", "industry"].includes(key)) normalizedKey = "industries";

      // Order (asc / desc)
      if (["order", "sortOrder", "direction"].includes(key)) {
        normalizedKey = "order";
      }
    }

    const finalValue = Array.isArray(value) ? value.join(",") : value;
    params.set(normalizedKey, finalValue);
  });

  // default orderType=Top
  if (route === "stock" && !params.has("orderType")) {
    params.set("orderType", "Top");
  }

  const queryString = params.toString();

  if (route === "stock" && symbol) {
    navigate(`/stock/${symbol}?${queryString}`);
  } else {
    navigate(`/trending?${queryString}`);
  }
};
